import React from 'react';
import { Formik } from 'formik';
import { Card, CardBody, Col, Row } from 'reactstrap';
import { useQuery } from '@apollo/client';
import { UI_SETTING_BY_NAME } from 'pages/ApplicationUI/ApplicationUIGraphQL';
import { APP_UI, termsValidationSchema } from 'pages/ApplicationUI/constant';
import Loader from 'components/common/Loader';
import ErrorBoundary from 'components/common/ErrorBoundary';
import ErrorMessage from 'components/ErrorMessage';
import TermsConditionsForm from './components/TermsConditionsForm';

const TermsAndConditions = ({ handleSubmit }) => {
  const { data, loading, error, refetch } = useQuery(UI_SETTING_BY_NAME, {
    variables: { settingName: APP_UI.TERMS_OF_USE },
    fetchPolicy: 'network-only',
  });

  if (error) {
    return <ErrorMessage error={error} />;
  }

  return (
    <Row>
      <Col xl={12}>
        <Card className="border-0 card-box">
          <CardBody>
            <h4 className="f-16 fw-semibold mb-3">Terms and conditions</h4>
            <ErrorBoundary>
              {loading ? (
                <Loader />
              ) : (
                <Formik
                  validationSchema={termsValidationSchema}
                  initialValues={data.findBySettingName || { settingValue: '' }}
                  onSubmit={(values) => handleSubmit(values, refetch)}
                  children={(props) => {
                    return <TermsConditionsForm {...props} />;
                  }}
                  enableReinitialize
                />
              )}
            </ErrorBoundary>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default TermsAndConditions;
